export const deafultTooltipProps = {
  borderRadius: '12px',
  paddingY: '8px',
  paddingX: '12px',
  color: '#fff',
  fontWeight: '400',
  fontSize: '12px',
  bg: '#303C4A',
};
